import React from 'react';

const Research = () => {
  return (
    <div className="content-section">
      <div className="container mx-auto px-4">
        <div className="glass-card rounded-lg p-8 md:p-12">
          <h1 className="text-4xl font-bold text-primary mb-6 text-center">
            Research & Global Operations
          </h1>
          <div className="w-24 h-1 bg-gold mx-auto mb-8"></div>
          
          <div className="max-w-4xl mx-auto space-y-6">
            <p className="text-lg text-gray-700 leading-relaxed text-center mb-8">
              Vajreya Ventures conducts comprehensive research and maintains global operations to serve clients across international markets with insights, strategies, and opportunities.
            </p>

            <h2 className="text-2xl font-bold text-primary mb-4">Research Services</h2>
            
            <div className="space-y-4 mb-8">
              <div className="bg-white border-2 gold-border rounded-lg p-6">
                <h3 className="text-xl font-bold text-primary mb-3">Market Research</h3>
                <p className="text-gray-700">
                  Our research team conducts in-depth market studies across industries and geographies. We analyze market dynamics, competitive landscapes, consumer trends, and regulatory environments to provide actionable insights for strategic decision-making.
                </p>
              </div>

              <div className="bg-white border-2 gold-border rounded-lg p-6">
                <h3 className="text-xl font-bold text-primary mb-3">Industry Analysis</h3>
                <p className="text-gray-700">
                  We provide comprehensive industry analysis covering sectors such as real estate, hospitality, infrastructure, media, and financial services. Our reports offer deep insights into industry trends, growth drivers, and investment opportunities.
                </p>
              </div>

              <div className="bg-white border-2 gold-border rounded-lg p-6">
                <h3 className="text-xl font-bold text-primary mb-3">Economic Research</h3>
                <p className="text-gray-700">
                  Our economists track macroeconomic indicators, policy changes, and global economic trends that impact investment decisions and business strategies. We provide regular economic briefings and forecasts.
                </p>
              </div>

              <div className="bg-white border-2 gold-border rounded-lg p-6">
                <h3 className="text-xl font-bold text-primary mb-3">Investment Research</h3>
                <p className="text-gray-700">
                  We conduct detailed investment research and due diligence on potential opportunities, analyzing financial performance, management quality, competitive positioning, and growth prospects.
                </p>
              </div>
            </div>

            <h2 className="text-2xl font-bold text-primary mb-4">Global Operations</h2>
            <p className="text-gray-700 mb-6">
              Vajreya Ventures operates with a global perspective, representing clients in international forums and facilitating cross-border business opportunities.
            </p>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
              <div className="bg-white border-2 gold-border rounded-lg p-6">
                <h3 className="text-xl font-bold text-primary mb-3">International Representation</h3>
                <p className="text-gray-700">
                  We represent clients in international business forums, conferences, and negotiations. Our global network enables us to connect clients with opportunities and partners worldwide.
                </p>
              </div>

              <div className="bg-white border-2 gold-border rounded-lg p-6">
                <h3 className="text-xl font-bold text-primary mb-3">Cross-Border Transactions</h3>
                <p className="text-gray-700">
                  We facilitate international transactions including mergers, acquisitions, joint ventures, and strategic partnerships. Our expertise spans regulatory compliance, cultural considerations, and deal structuring.
                </p>
              </div>

              <div className="bg-white border-2 gold-border rounded-lg p-6">
                <h3 className="text-xl font-bold text-primary mb-3">Global Market Entry</h3>
                <p className="text-gray-700">
                  We help clients enter new international markets through comprehensive market entry strategies, local partnership development, and regulatory navigation.
                </p>
              </div>

              <div className="bg-white border-2 gold-border rounded-lg p-6">
                <h3 className="text-xl font-bold text-primary mb-3">Strategic Partnerships</h3>
                <p className="text-gray-700">
                  We identify and facilitate strategic partnerships across borders, creating value through collaboration, knowledge sharing, and complementary capabilities.
                </p>
              </div>
            </div>

            <h2 className="text-2xl font-bold text-primary mb-4">Agreement Negotiation</h2>
            <p className="text-gray-700 mb-8">
              Vajreya Ventures negotiates complex agreements on behalf of clients, including joint venture agreements, investment agreements, partnership agreements, and commercial contracts. Our negotiation expertise ensures favorable terms while maintaining strong business relationships.
            </p>

            <h2 className="text-2xl font-bold text-primary mb-4">Geographic Focus</h2>
            <p className="text-gray-700 mb-4">
              While headquartered in Bangalore, India, our operations span multiple regions:
            </p>
            <ul className="space-y-3 text-gray-700 mb-8">
              <li className="flex items-start">
                <span className="gold-text mr-2">•</span>
                <span><strong>India:</strong> Deep local expertise across major cities and emerging markets</span>
              </li>
              <li className="flex items-start">
                <span className="gold-text mr-2">•</span>
                <span><strong>Asia-Pacific:</strong> Active presence in key Asian markets</span>
              </li>
              <li className="flex items-start">
                <span className="gold-text mr-2">•</span>
                <span><strong>Middle East:</strong> Growing operations in Gulf countries</span>
              </li>
              <li className="flex items-start">
                <span className="gold-text mr-2">•</span>
                <span><strong>Global Networks:</strong> Strategic partnerships across continents</span>
              </li>
            </ul>

            <div className="bg-gradient-to-r from-primary to-primary-dark text-white rounded-lg p-8 text-center">
              <h3 className="text-2xl font-bold mb-4">Expand Globally</h3>
              <p className="mb-6">
                Leverage our research capabilities and global operations to drive your international growth.
              </p>
              <a 
                href="/contact" 
                className="inline-block px-8 py-3 bg-gold text-white font-semibold rounded-lg hover:bg-gold-dark transition-colors shadow-lg"
              >
                Connect With Us
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Research;